export const UXPermissions = {
    LMSEventDefinitionToolAccess: {
        resourceId: "fac10c87-5627-4e60-80df-e0fc467fe73e",
        action: "Read",
    }
};

